
import Features from './features';

export default class Accordion {

  static init() {
    this.initAccordion();
  }


  /**
   * find all accordion target attributes for triggering accordions
   */
  static initAccordion() {

    var accordions = document.querySelectorAll('[data-accordion-target-id]');

    accordions.forEach(function(accordion) {
      accordion.addEventListener('click', function() {
        var accordion_id = this.getAttribute("data-accordion-target-id");
        var accordion_target = document.querySelector('[data-accordion-item="'+accordion_id+'"]');
        var inside_feature_brick = this.parentElement.parentElement.classList.contains('accordion-feature');

        if (inside_feature_brick) {
          Features.closeFeatureAccordions(accordion_target);
          Features.showFeatureImageVideo(accordion_id);
        }

        if (accordion_target) {
          if(accordion_target.getAttribute('data-accordion-active') == 'false') {
            accordion_target.setAttribute("data-accordion-active", "true");
          } else {
            accordion_target.setAttribute("data-accordion-active", "false");
          }
          if (this.hasAttribute('aria-expanded')) {
            this.setAttribute('aria-expanded', accordion_target.getAttribute('data-accordion-active'));
          }
        }
      });
    });
  }

}
